// extracted by mini-css-extract-plugin
module.exports = {"introduce_item":"StartAssessment_introduce_item__3EdiF"};